import ReceiptForm from "./ReceiptForm";
import ReceiptsTable from "./ReceiptsTable";

export default ReceiptForm;
export { ReceiptsTable };
